var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEllipse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1111,
    height: 834,
    viewBox: "0 0 1111 834",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1112 0C1111.2 196.021 925.666 253.009 833 257H1112V0Z",
    fill: "#1D4C92"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 305C0 277.386 22.3858 255 50 255H1112V678C1112 764.156 1042.16 834 956 834H50C22.3857 834 0 811.614 0 784V305Z",
    fill: "#1D4C92"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEllipse);
export default __webpack_public_path__ + "static/media/ellipse.8a34c4bf5a8382b6a0078c73805b3473.svg";
export { ForwardRef as ReactComponent };